import React, { FC, useEffect } from 'react'
import styles from './UserAccountPage.module.scss'
import { SidebarNavigation } from 'components/SidebarNavigation/SidebarNavigation'
import { UserAccountRoutes } from './UserAccountRoutes'

import { DefaultFooter } from 'components/page/footer/defaultFooter/DefaultFooter'
import { locales } from 'translations/i18n'
import { Breakpoint, useCurrentBreakpoint } from 'hooks/CurrentBreakpoint'
import { UserAccountMenuLinks } from './UserAccountMenuLinks'
import useCurrentUser from 'hooks/CurrentUser'

import { Helmet } from 'react-helmet-async'
import { useScrollToTop } from 'helpers/useScrollToTop'
import { useDispatch } from 'react-redux'
import authenticationActions from 'redux-store/authentication/authentication.actions'
import { NotSignedInContent } from './NotSignedInContent/NotSignedInContent'

export const UserAccountPage: FC = () => {
  const companyName = 'Solidsport AB'
  const currentBreakpoint = useCurrentBreakpoint()
  const isMobile = currentBreakpoint <= Breakpoint.sm
  const currentUser = useCurrentUser()
  const dispatch = useDispatch()

  useScrollToTop()
  useEffect(() => {
    if (!currentUser?.firstname) {
      dispatch(authenticationActions.openLoginLayer(undefined, 'login'))
    }
  }, [currentUser])

  return (
    <div className={styles.PageContainer}>
      <Helmet>
        <title>Solidsport Account</title>
      </Helmet>
      {currentUser && !isMobile && (
        <div className={styles.Sidebar}>
          <SidebarNavigation
            menuLinks={UserAccountMenuLinks}
            showSignOutButton={true}
            onSignOutClick={() => null}
          />
        </div>
      )}
      {currentUser ? (
        <div className={styles.Content}>
          <UserAccountRoutes />
          <DefaultFooter companyName={companyName} languages={locales} />
        </div>
      ) : (
        <NotSignedInContent />
      )}
    </div>
  )
}
